import React, { Fragment } from 'react'

import { ActivityCounts as ActivityCountsType } from 'modules/accountActivity/domain'
import PortalTooltip from 'sections/GroupedActivities/PortalTooltip'
import { formatNumber } from 'utils/formatNumbers'

import { ReactComponent as Conversation } from '../../../svgs/activities/Conversation.svg'
import { ReactComponent as Email } from '../../../svgs/activities/Email.svg'
import { ReactComponent as Meeting } from '../../../svgs/activities/Meeting.svg'
import { ReactComponent as SiteVisit } from '../../../svgs/activities/SiteVisit.svg'
import { ReactComponent as Video } from '../../../svgs/activities/Video.svg'

import styles from './styles.module.css'

interface ActivityCountsProps {
  activityCounts: ActivityCountsType
}

const ActivityCounts: React.FC<ActivityCountsProps> = ({ activityCounts }) => {
  const {
    CONVERSATION,
    EMAIL_CLICK,
    EMAIL_OPEN,
    EMAIL_SEND,
    END_USER_IDENTIFIED,
    MEETING_BOOKED,
    MEETING_CANCELED,
    MEETING_RESCHEDULED,
    PAGE_VIEW,
    VIDEO
  } = activityCounts

  const total = Object.values(activityCounts).reduce((sum: number, value: number) => sum + value, 0)

  const format = (value: number | undefined, singular: string, plural: string) => {
    return !value ? '' : `${formatNumber(value)} ${value === 1 ? singular : plural}`
  }

  return (
    <PortalTooltip
      component={[
        format(MEETING_BOOKED, 'meeting booked', 'meetings booked'),
        format(MEETING_CANCELED, 'meeting canceled', 'meetings canceled'),
        format(MEETING_RESCHEDULED, 'meeting rescheduled', 'meetings rescheduled'),
        format(CONVERSATION, 'conversation', 'conversations'),
        format(VIDEO, 'video view', 'video views'),
        format(PAGE_VIEW, 'site visit', 'site visits'),
        format(EMAIL_CLICK, 'email clicked', 'emails clicked'),
        format(EMAIL_OPEN, 'email opened', 'emails opened'),
        format(EMAIL_SEND, 'email delivered', 'emails delivered'), // TODO: Remove me
        format(END_USER_IDENTIFIED, 'email provided', 'emails provided')
      ]
        .filter(Boolean)
        .map((line: string, index: number) => (
          <Fragment key={index}>
            {index > 0 && <br />}
            {line}
          </Fragment>
        ))}>
      <div className={styles.ActivityCounts}>
        <span className={styles.total}>{formatNumber(total)}</span>
        <span className={styles.icons}>
          {/*
              These are in reverse order because the styling uses `flex-direction:
              row-reverse` to get an overlapping effect without the need to mess
              with the z-index of each element.
          */}
          {(EMAIL_CLICK || EMAIL_OPEN || EMAIL_SEND || END_USER_IDENTIFIED) && <Email />}
          {PAGE_VIEW && <SiteVisit />}
          {VIDEO && <Video />}
          {CONVERSATION && <Conversation />}
          {(MEETING_BOOKED || MEETING_CANCELED || MEETING_RESCHEDULED) && <Meeting />}
        </span>
      </div>
    </PortalTooltip>
  )
}

export default ActivityCounts
